import {
  AMORTIZATION_FACTOR,
  DEERE_DISCOUNT,
  LEASE,
  LEASE_RATE,
  MDP,
  RETAIL_INSTALLMENT_RATE,
  RETAIL_NOTE,
} from "../utilities/constants.js";

export function calculateSpreadAndMargin(props) {
  return (dispatch, getState) => {
    let { transactions } = getState();
    let deereNormalizedTP = 0;
    let compNormalizedTP = 0;
    let finalSpreadCompPercent;
    let spreadOnMachine = 0.0;
    let spreadOnPrograms = 0.0;
    let finalSpreadComp = 0.0;
    let deereAdjMacPrice = 0.0;
    let spreadCalcTransactionDeere;
    let spreadCalcTransactionComp;

    transactions.bids.forEach((bid, index) => {
      if (bid.bidType === "JD") {
        spreadCalcTransactionDeere = calculateSpread(
          props,
          bid.bidType,
          index,
          transactions
        );
        deereNormalizedTP =
          spreadCalcTransactionDeere.bids[index].calcNormalizeTp;
        deereAdjMacPrice =
          spreadCalcTransactionDeere.bids[index].calcAdjustMacPrice;
        calculateGrossMargin(
          props,
          bid.bidType,
          index,
          spreadCalcTransactionDeere
        );
      } else {
        spreadCalcTransactionComp = calculateSpread(
          props,
          bid.bidType,
          index,
          transactions
        );
        compNormalizedTP =
          spreadCalcTransactionComp.bids[index].calcNormalizeTp;
        spreadOnMachine =
          deereAdjMacPrice -
          spreadCalcTransactionComp.bids[index].calcAdjustMacPrice;
        spreadOnPrograms =
          deereNormalizedTP - compNormalizedTP - spreadOnMachine;
        finalSpreadComp = deereNormalizedTP - compNormalizedTP;
        finalSpreadCompPercent = 0.0;
        if (deereAdjMacPrice !== 0.0) {
          finalSpreadCompPercent =
            ((deereNormalizedTP - compNormalizedTP) / deereAdjMacPrice) * 100;
        }
        if (
          !isNaN(spreadOnMachine) &&
          !isNaN(spreadOnPrograms) &&
          !isNaN(finalSpreadComp) &&
          !isNaN(finalSpreadCompPercent)
        ) {
          props.setBidsTextValue(
            "calcMachSpread",
            spreadOnMachine ? Math.round(spreadOnMachine).toFixed(2) : "",
            bid.bidType
          );
          props.setBidsTextValue(
            "calcProgSpread",
            spreadOnPrograms ? Math.round(spreadOnPrograms).toFixed(2) : "",
            bid.bidType
          );
          props.setBidsTextValue(
            "calcFinalSpread",
            finalSpreadComp ? Math.round(finalSpreadComp).toFixed(2) : "",
            bid.bidType
          );
          props.setBidsTextValue(
            "calcFinalSpreadPct",
            finalSpreadCompPercent ? finalSpreadCompPercent.toFixed(1) : "",
            bid.bidType
          );
        } else {
          props.setBidsTextValue(
            "calcMachSpread",
            spreadOnMachine ? Math.round(spreadOnMachine).toFixed(2) : 0.0,
            bid.bidType
          );
          props.setBidsTextValue(
            "calcProgSpread",
            spreadOnPrograms ? Math.round(spreadOnPrograms).toFixed(2) : 0.0,
            bid.bidType
          );
          props.setBidsTextValue(
            "calcFinalSpread",
            finalSpreadComp ? Math.round(finalSpreadComp).toFixed(2) : 0.0,
            bid.bidType
          );
          props.setBidsTextValue(
            "calcFinalSpreadPct",
            finalSpreadCompPercent ? finalSpreadCompPercent.toFixed(1) : 0.0,
            bid.bidType
          );
        }
      }
    });
  };
}

function calculateSpread(props, bidType, compIndex, transactions) {
  let PMT_TYPE = 1;
  let DiscRate = LEASE_RATE / 100.0 / 12.0;
  let normalizedTP;
  let salesPrice = 0;
  let intRate = transactions.bids[compIndex].paymentType.finRate;

  if (transactions?.bids[compIndex] && parseInt(transactions.bids[compIndex].paymentType?.finRate) === 0) {
    intRate = 0.00001;
  }

  salesPrice = transactions.bids[compIndex].saleAmtPerUnit;
  if (transactions.bids[compIndex].paymentType.paymentType === LEASE.title) {
    salesPrice = salesPriceLease(
      transactions.bids[compIndex].paymentType,
      DiscRate,
      PMT_TYPE
    );
  }

  let adjMachPrice = salesPrice;
  let cashdown = parseInt(transactions.bids[compIndex].paymentType.cashDown);
  normalizedTP = adjMachPrice;

  if (
    transactions.bids[compIndex].paymentType.paymentType === RETAIL_NOTE.title
  ) {
    normalizedTP =
      adjMachPrice -
      valueOfRetailFinance(
        cashdown,
        salesPrice,
        intRate,
        transactions.bids[compIndex].paymentType.noOfMonths,
        RETAIL_INSTALLMENT_RATE
      );
    if (parseInt(transactions.bids[compIndex].paymentType.noOfMonths) === 0)
      normalizedTP = 0;
  }

  transactions.bids[compIndex].calcAdjustMacPrice = adjMachPrice;
  transactions.bids[compIndex].calcNormalizeTp = normalizedTP;

  if (!isNaN(salesPrice) && !isNaN(adjMachPrice) && !isNaN(normalizedTP)) {
    props.setBidsTextValue(
      "calcLeasePrice",
      salesPrice ? Math.round(salesPrice).toFixed(2) : "",
      bidType
    );
    props.setBidsTextValue(
      "calcAdjustMacPrice",
      adjMachPrice ? Math.round(adjMachPrice).toFixed(2) : "",
      bidType
    );
    props.setBidsTextValue(
      "calcNormalizeTp",
      normalizedTP ? Math.round(normalizedTP).toFixed(2) : "",
      bidType
    );
  } else {
    props.setBidsTextValue(
      "calcLeasePrice",
      salesPrice ? Math.round(salesPrice).toFixed(2) : 0.0,
      bidType
    );
    props.setBidsTextValue(
      "calcAdjustMacPrice",
      adjMachPrice ? Math.round(adjMachPrice).toFixed(2) : 0.0,
      bidType
    );
    props.setBidsTextValue(
      "calcNormalizeTp",
      normalizedTP ? Math.round(normalizedTP).toFixed(2) : 0.0,
      bidType
    );
  }
  return transactions;
}

function salesPriceLease(paymentType, DiscRate, PMTTYPE) {
  let { monthlyPayment, noOfMonths, purchOptAmt } = paymentType;
  let salesPrice = 0;
  salesPrice =
    monthlyPayment *
      ((1 - Math.pow(1 + DiscRate, -noOfMonths)) / DiscRate) *
      (1 + DiscRate * PMTTYPE) +
    purchOptAmt * Math.pow(1 + DiscRate, -noOfMonths);
  return salesPrice;
}

function valueOfRetailFinance(
  cashDown,
  salesPrice,
  intRate,
  RetailNoOfMonths,
  retailInstallmentRate
) {
  let FV = 1;
  let PMTTYPE = 0;
  let AmountFinanced = salesPrice - parseInt(cashDown);
  intRate = intRate / 100 / 12;
  let firstpart = AmountFinanced * intRate;
  let secondpart = 1 - Math.pow(1 + intRate, -RetailNoOfMonths);
  let PMT;
  if (intRate === 0) {
    PMT = 0;
  } else {
    if (secondpart !== 0.0) {
      PMT = firstpart / secondpart;
    } else {
      PMT = 0;
    }
  }
  let DiscRate = retailInstallmentRate / 100 / 12;
  let PV = calculateRetailFinanceValue(
    PMT,
    DiscRate,
    RetailNoOfMonths,
    FV,
    PMTTYPE
  );
  let CostsSum = PV + parseInt(cashDown);
  return salesPrice - CostsSum;
}

function calculateRetailFinanceValue(
  PMT,
  DiscRate,
  RetailNoOfMonths,
  FV,
  PMTTYPE
) {
  let retailFinanceValue =
    PMT *
      ((1 - Math.pow(1 + DiscRate, -RetailNoOfMonths)) / DiscRate) *
      (1 + DiscRate * PMTTYPE) +
    FV * Math.pow(1 + DiscRate, -RetailNoOfMonths);
  return retailFinanceValue;
}

function calculateGrossMargin(props, bidType, compIndex, transactions) {
  let grossMargin;
  let salePriceforMargin = parseFloat(
    transactions.bids[compIndex].saleAmtPerUnit
  );
  let originalMDP = parseFloat(transactions.bids[compIndex].machineOrigMDP);
  let deereDiscountApplied = parseFloat(
    transactions.bids[compIndex].totDiscountApplied
  );
  let costOfParts = parseFloat(transactions.bids[compIndex].extAttachCost);
  let freightPdi = parseFloat(transactions.bids[compIndex].freightPDICost);
  let FinBuyDownCost = parseFloat(transactions.bids[compIndex].finBuyDownCost);
  let otherAdditionalDealerCost = parseFloat(
    transactions.bids[compIndex].addnlDlrCost
  );
  let rentalIncome = parseFloat(transactions.bids[compIndex].rentalIncome);
  let grossMarginPct = 0.0;
  if (rentalIncome > 0) {
    rentalIncome = rentalIncome * AMORTIZATION_FACTOR;
  }

  grossMargin =
    salePriceforMargin +
    rentalIncome -
    originalMDP +
    deereDiscountApplied -
    costOfParts -
    freightPdi -
    FinBuyDownCost -
    otherAdditionalDealerCost;

  if (salePriceforMargin !== 0.0) {
    grossMarginPct = (grossMargin / salePriceforMargin) * 100;
  } else {
    grossMargin = 0.0;
    grossMarginPct = 0.0;
  }

  if (originalMDP <= MDP || deereDiscountApplied < DEERE_DISCOUNT) {
    grossMargin = 0.0;
    grossMarginPct = 0.0;
  }

  if (!isNaN(grossMargin) && !isNaN(grossMargin)) {
    props.setBidsTextValue(
      "calcGrossMargin",
      grossMargin ? Math.round(grossMargin).toFixed(2) : "",
      bidType
    );
    props.setBidsTextValue(
      "calcGrossMarginPct",
      grossMargin ? grossMarginPct.toFixed(2) : "",
      bidType
    );
  } else {
    props.setBidsTextValue(
      "calcGrossMargin",
      grossMargin ? Math.round(grossMargin).toFixed(2) : 0.0,
      bidType
    );
    props.setBidsTextValue(
      "calcGrossMarginPct",
      grossMargin ? grossMarginPct.toFixed(2) : 0.0,
      bidType
    );
  }
}
